module.exports = __webpack_public_path__ + "img/SubHeader.861fc2f6.png";